/**
 * Raw WebSocket transport for WAHA (same protocol as proventi-app).
 *
 * After `open`, send JSON: `{ type: "subscribe", channel: "branch:{code}" }`.
 */

export type WahaRawSocketHandlers = {
  onOpen: () => void;
  onMessage: (data: string) => void;
  onClose: () => void;
  onError?: (error: unknown) => void;
};

export function connectWahaRawSocket(
  url: string,
  handlers: WahaRawSocketHandlers,
): WebSocket {
  const ws = new WebSocket(url);

  ws.onopen = () => {
    handlers.onOpen();
  };

  ws.onmessage = (event) => {
    handlers.onMessage(String(event.data ?? ''));
  };

  ws.onclose = () => {
    handlers.onClose();
  };

  ws.onerror = (error) => {
    handlers.onError?.(error);
  };

  return ws;
}

export function closeWahaRawSocket(
  ws: WebSocket | null,
  options?: { unsubscribeFrames?: string[] },
): void {
  if (!ws) {
    return;
  }

  try {
    if (ws.readyState === WebSocket.OPEN && options?.unsubscribeFrames?.length) {
      for (const frame of options.unsubscribeFrames) {
        ws.send(frame);
      }
    }
  } catch {
    // no-op
  }

  try {
    ws.onopen = null;
    ws.onmessage = null;
    ws.onclose = null;
    ws.onerror = null;
    ws.close();
  } catch {
    // no-op
  }
}

export function isWahaRawSocketOpen(ws: WebSocket | null): boolean {
  return ws?.readyState === WebSocket.OPEN;
}
